import React from 'react'
import PropTypes from 'prop-types'
import {LOCAL_KEY, feedCodeToTitle} from '../../constants'
import CFXProReactTable from '../cfxProReactTable'
import {reactTableColumn} from '../../helpers/reactTable'
import {buildLastUpdateFooter} from '../../helpers/textbuilders'
import {connect} from 'react-redux'
import {updateFeedData, updateIsFetchingFeedData} from '../../actions'
import api from '../../api'

@connect((state) => {
  const {
    data: {dtn},
    app: {isFetchingFeedData},
  } = state

  return {
    isFetchingFeedData,
    data: dtn,
  }
})
@api
class FuturesMain extends React.Component {
  buildTableData(data) {
    if (data == null) {
      return []
    }

    return [
      this.buildRow(data, LOCAL_KEY.dtnLiveCattle),
      this.buildRow(data, LOCAL_KEY.dtnFeeder),
      this.buildRow(data, LOCAL_KEY.dtnCDN),
      this.buildRow(data, LOCAL_KEY.dtnCorn),
    ]
  }

  buildRow(data, code) {
    if (data == null) {
      return {}
    }

    return {
      feed: feedCodeToTitle(code),
      code: code,
      roundTo: code === 'cdn' ? 4 : 2,
      last: Number(data[code].latest.lastValue),
      change: Number(data[code].latest.changeValue),
    }
  }

  render() {
    const {data, isFetchingFeedData, apiInstance, dispatch} = this.props
    let tableData = this.buildTableData(data)
    let footerDate = data == null ? null : data.lastUpdated

    return (
      <div>
        <CFXProReactTable
          fixedHeaders={true}
          footerText={buildLastUpdateFooter(
            'Courtesy of DTN\nPrice as of (date) at (time)',
            footerDate,
          )}
          highlightColumns={['FEED']}
          titleText="FUTURES"
          rightButtonIconName={
            isFetchingFeedData ? 'fa-sync-alt fa-spin' : 'fa-sync-alt'
          }
          rightButtonCallback={() => {
            dispatch(updateIsFetchingFeedData(true))
            apiInstance.get('getdata').then((data) => {
              dispatch(updateFeedData(data))
              dispatch(updateIsFetchingFeedData(false))
            })
          }}
          data={tableData}
          loading={isFetchingFeedData}
          className="-striped -highlight"
          showPagination={false}
          defaultPageSize={4}
          columns={[
            reactTableColumn('FEED', 'feed'),
            reactTableColumn('LAST', 'last'),
            reactTableColumn('CHANGE', 'change'),
          ]}
          getTrProps={(state, rowInfo, column, instance) => {
            return {
              className: 'cfx-selectable',
              onClick: (e, handleOriginal) => {
                this.props.history.push(`/futures/${rowInfo.original.code}`)
              },
            }
          }}
        />
        <div className="cfx-cme-logo" />
      </div>
    )
  }
}

const propTypeFuturesFeedItem = PropTypes.shape({
  changeValue: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  lastValue: PropTypes.string.isRequired,
  month: PropTypes.number.isRequired,
  symbol: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
})

const propTypeFuturesFeed = PropTypes.shape({
  latest: propTypeFuturesFeedItem.isRequired,
  all: PropTypes.arrayOf(propTypeFuturesFeedItem).isRequired,
})

FuturesMain.propTypes = {
  data: PropTypes.shape({
    lastUpdate: PropTypes.instanceOf(Date),
    livecattle: propTypeFuturesFeed,
    feeder: propTypeFuturesFeed,
    cdn: propTypeFuturesFeed,
    corn: propTypeFuturesFeed,
  }),
}

export default FuturesMain



// WEBPACK FOOTER //
// ./src/components/futures/main.js